import { useEffect } from "react";
import Lenis from "lenis";
import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Navbar from "@/components/Navbar";
import WhatsAppFloat from "@/components/WhatsAppFloat";
import Home from "@/pages/Home";
import Restaurants from "@/pages/Restaurants";
import CloudKitchen from "@/pages/CloudKitchen";
import HospitalCanteen from "@/pages/HospitalCanteen";
import Investors from "@/pages/Investors";
import Contact from "@/pages/Contact";
import Franchisee from "@/pages/Franchisee";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    if (window.__lenis) window.__lenis.scrollTo(0, { immediate: true });
    else window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

function App() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    window.__lenis = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <BrowserRouter>
      <div className="min-h-screen overflow-x-clip bg-obsidian text-cream" data-testid="app-root">
        <ScrollToTop />
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/restaurants" element={<Restaurants />} />
          <Route path="/cloud-kitchen" element={<CloudKitchen />} />
          <Route path="/hospital-canteen" element={<HospitalCanteen />} />
          <Route path="/investors" element={<Investors />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/franchisee" element={<Franchisee />} />
          <Route path="*" element={<Home />} />
        </Routes>
        <WhatsAppFloat />
        <Toaster position="top-center" richColors />
      </div>
    </BrowserRouter>
  );
}

export default App;
